module.exports = __webpack_public_path__ + "static/img/body_2.1761547470324.png";